import { render, staticRenderFns } from "./LeadsContacts.vue?vue&type=template&id=4e4970f2&"
import script from "./LeadsContacts.vue?vue&type=script&lang=js&"
export * from "./LeadsContacts.vue?vue&type=script&lang=js&"
import style0 from "./LeadsContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports